export const live = {
    zbz: "Live Streaming",
    ljks: "Start Now",
    hmyzb: "You haven't started any live streams yet~",
    zbyg: "Live Stream Preview",
    yjs: "Ended",
    jszb: "End Live Stream",
    gbzb: "Close Live Stream",
    jxzb: "Continue Live Stream",
    bctp: "Save Image",
    fxlj: "Share Link",
    zbydk: "Live stream disconnected, please wait...",
    fh: "Back",
    wjcdypsb: "No audio device detected",
    czsb: "Canvas operation failed:",
    tpjzsb: "Image loading failed, please check if the URL is correct and the image is accessible",
    zbjl: "Live Stream History",
    sqjl: "Application History",
    lts: "Chat Room",
    ren: "people",
    gdcy: "More Members",
    cy: "Members",
    jcjy: "Unmute",
    jy: "Mute",
    qbjy: "Mute All",
    zbjs: "Live Stream Introduction",
    srnr: "Please enter content",
    tczbj: "You have been removed from the live stream",
    qd: "Confirm",
    zbjjjs: "Your live stream will automatically end in 10 minutes!",
    zbsc: "Live Stream Duration:",
    ljgkrs: "Total Viewers:",
    dzs: "Likes:",
    zbjies: "Live Stream Ended",
    ybjy: "You have been muted",
    jycg: "Unmuted Successfully",
    jinycg: "Muted Successfully",
    qbjinycg: "All Muted Successfully",
    qbjycg: "All Unmuted Successfully",
    cwzb: "Become a Streamer",
    lxgzry: "Please contact staff to become a streamer",
    lxfs: "Contact Information",
    zb: "Live Stream",
    xkt: "Biking Tutorial",
    sqzb: "Apply for Live Stream",
    bczbzt: "Live Stream Topic",
    srzt: "Please enter topic",
    bczbjj: "Live Stream Introduction",
    kbsj: "Start Time",
    xzrisj: "Select Date and Time",
    tishi: "Prompt",
    dksdzb: "There is 1 scheduled live stream at this time",
    cxsj: "Duration",
    xzsc: "Select Duration",
    fmt: "Cover Image",
    fmtbnwk: "Cover image cannot be empty",
    sc: "Upload",
    yssc: "Max 10MB, please compress before uploading",
    sccct: "Please upload image with 360*170 dimensions",
    tjsq: "Submit Application",
    tpcj: "Image Cropping",
    tzcjwz: "Adjust crop frame position, select area to keep",
    scdtp: "Uploaded Image",
    yl: "Preview (360×170)",
    cjtp: "Crop Image",
    quxiao: "Cancel",
    qsrzbjj: "Please enter live stream introduction",
    qxzrq: "Please select date",
    qxzsc: "Please select duration",
    kssjdydqsj: "Start time must be later than current time",
    sctxtpdx: "Uploaded avatar size cannot exceed 10MB!",
    tjcg: "Submission Successful",
    jkshnr: "We will review your application content as soon as possible",
    hmysqgzb: "You haven't applied for any live streams yet~",
    shz: "Under Review",
    tongg: "Approved",
    jujue: "Rejected",
    yugao: "Preview",
    huifang: "Replay",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/live/en.js